import { VERTICAL_ASPECT_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const storiesPage: TemplatePage = {
  header: {
    color: '#CCADE6',
    icon: 'images/video-templates/instagram-stories_v1.jpg',
    title: 'Instagram Story Video Templates',
    title_meta: '200+ Free Instagram Story Video Templates',
    description_meta:
      'Use your IG Stories to their fullest potential with Wave.video’s 200+ customizable Instagram Story video templates.',
    description:
      'Use your IG Stories to their fullest potential with these 200+ customizable Instagram Story video ' +
      'templates. Easily create compelling ephemeral video content that your followers will be excited about.'
  },
  footer: {
    category: 'Instagram Reels & Stories',
    description:
      'With Wave.video’s collection of easy-to-edit Instagram Story video templates, you will be able to effortlessly ' +
      'create engaging videos for your Stories in minutes. Just pick a template of your liking, customize it for your ' +
      'brand, and download the resulting video. Quick and simple!'
  },
  content: [
    {
      type: 'templates',
      title: 'Instagram Reels & Stories',
      search: {
        aspects: VERTICAL_ASPECT_STRING
      }
    },
    { type: 'stocks', title: 'stories', search: { name: 'stories' } },
    { type: 'calendar' }
  ]
};

export default storiesPage;
